import React from 'react';
import { Link } from 'react-router-dom';

import Footer from './Footer';

export default function Homepage() {
  return (
    <>
      <div className='homepage-container content-container'>
        <img
          src='/images/Horizontal-logo-Wmargin.png'
          className='logo'
          alt='company logo'
        />
        <h1>
          Data and technology drive dealmaking success. How does your firm
          measure up?
        </h1>
        <p className='page-subtitle'>
          Answer 3 quick questions to learn how your firm compares to peers.
        </p>
          <div className='button-bg'>
            <Link to='/1'><button id='start'>Start</button></Link>
          </div>
      </div>
      <Footer />
    </>
  );
}
